import React from "react";
import { Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ({ image, txt1, txt2, btxt }) {
  const { t } = useTranslation();
  return (
    <Container>
      <Stack
        sx={{
          alignItems: "center",
          borderRadius: "25px",
          backgroundImage: `url(${image})`,
          position: "relative",
        }}
      >
        <div
          style={{
            width: "90%",
            borderRadius: "20px",
            objectFit: "cover",
            height: "500px",
          }}
        >
          <Typography
            sx={{
              color: "#1D2877",
              fontWeight: "bold",
              fontSize: "25px",
              marginTop: "8%",
            }}
          >
            {t(txt1)}
            <br />
            {t(txt2)}
          </Typography>
        </div>
        {btxt && (
          <Button
            sx={{
              position: "absolute",
              bottom: "25px",
              right: "40px",
              borderRadius: "10px",
              backgroundColor: "#1D2877",
              color: "white",
              "&:hover": { color: "white", backgroundColor: "#9DCAFA " },
            }}
          >
            <a
              className="nav-link"
              href="https://play.google.com/store/apps/details?id=com.ma.ma_app_client"
            >
              {t(btxt)}
            </a>
          </Button>
        )}
      </Stack>
    </Container>
  );
}
